import {
    server
} from "@/api";

const prefix = 'api/documents'

export const admin = {
    create: async (document) => {
        return await server().post(prefix, document)
    }
}

export const create = async (document) => {
    return await server().post(prefix, document, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const get = async (id) => {
    return await server().get(`${prefix}/${id}`)
}

export const update = async (id, document) => {
    return await server().post(`${prefix}/${id}`, document, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const destroy = async (id) => {
    return await server().delete(`${prefix}/${id}`)
}

export const paginate = async (params) => {
    return await server().get(`${prefix}`, { params })
}

export const all = async () => {
    return await server().get(`${prefix}/all`)
}